// Admin Users Tab Component
import React from 'react';
import { GroupBox } from '../shared/GroupBox';
import { format } from 'date-fns';
import { useAdmin } from './AdminContext';

export function AdminUsersTab() {
  const { users } = useAdmin();

  return (
    <div className="space-y-4">
      <GroupBox title={`Users (${users.length})`} className="border-blue-500/50">
        <div className="p-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-2 px-3">User</th>
                <th className="text-left py-2 px-3">Email</th>
                <th className="text-center py-2 px-3">Role</th>
                <th className="text-left py-2 px-3">Tenant</th>
                <th className="text-left py-2 px-3">Created</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.user_id} className="border-b border-gray-800">
                  <td className="py-2 px-3">
                    <div className="flex items-center gap-2">
                      {u.picture && <img src={u.picture} alt="" className="w-8 h-8 rounded-full" />}
                      <div>
                        <div>{u.name}</div>
                        <div className="text-xs text-gray-500">{u.user_id}</div>
                      </div>
                    </div>
                  </td>
                  <td className="py-2 px-3">{u.email}</td>
                  <td className="py-2 px-3 text-center">
                    <span className={`px-2 py-1 rounded text-xs ${
                      u.role === 'superadmin' ? 'bg-yellow-500/20 text-yellow-500' :
                      u.role === 'admin' ? 'bg-purple-500/20 text-purple-500' :
                      'bg-gray-500/20 text-gray-400'
                    }`}>
                      {u.role}
                    </span>
                  </td>
                  <td className="py-2 px-3 text-gray-400">{u.tenant_id}</td>
                  <td className="py-2 px-3 text-gray-400">
                    {format(new Date(u.created_at), 'MMM d, yyyy')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </GroupBox>
    </div>
  );
}
